import React, { Component } from "react";
import { Row, Col, Steps, Popover } from "antd";
import { connect } from "react-redux";
import { AuthAction } from "../../store/actions";
import Register from "./register";
import Profile from "./profile";
import Personalize from "./personalize";
import AddPlant from "./Addplant";
import BuildMain from "./buildMain";
import { AiOutlineTwitter, FaFacebookF, FaInstagram } from "react-icons/all";
import RmxFooterImage from "../../assets/images/footerIcon.png";
import RmxFooter from "../../assets/images/footer.png";
class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      userInfo: {},
    };
  }
  userData = (data) => {
    this.setState({
      userInfo: data,
    });
  };
  componentDidMount(){
    this.props.getScreenName('register')
  }
  render() {
    const { count } = this.state;
    return (
      <Row justify="center">
        <Col span={20}>
          <Register
            loader={this.props.loader}
            count={count}
            onChangeStep={() =>
              this.setState({
                count: this.state.count + 1,
              })
            }
            userData={this.userData}
          />
        </Col>

        <Col span={24}>
          <Row>
            <Col
              xl={24}
              className="rmx-containers"
              style={{
                fontWeight: "500",
                backgroundImage: `url(${RmxFooter})`,
              }}
            >
              <Row
                className="rmx-footer-row"
                justify="space-between"
                align="middle"
              >
                <Col xl={6}>
                  <img
                    src={RmxFooterImage}
                    className="rmx-footer-image"
                    height={250}
                    width={250}
                  />
                </Col>
                <Col xl={8}>
                  <Row>
                    <Col span={24}>
                      <h3 style={{ fontWeight: "750" }}>MAIN-FRAME</h3>
                    </Col>
                    <Col span={24}>
                      <span>
                        888 Prospect Street, Suite 200, La Jolla, CA 92037
                      </span>
                    </Col>
                    <Col span={24}>
                      <span>info@main-frame.com </span>
                    </Col>
                    <Col span={24}>
                      <span>+1 619 880 0265</span>
                    </Col>
                  </Row>
                </Col>

                <Col xl={6} style={{ paddingBottom: "50px" }}>
                  
                </Col>
              </Row>
              <Col
                className="rmx-copyright"
                style={{ color: "black", fontWeight: "600" }}
              >
                <span>
                  © {new Date().getFullYear()} Main Frame . All Rights Reserved.
                </span>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signup: (payload, cb) => dispatch(AuthAction.SignUp(payload, cb)),
    getScreenName:(payload)=>dispatch(AuthAction.getScreenName(payload))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
